import { z } from "zod";

// ============================================
// SITE INSPECTION ENTITY SCHEMA
// ============================================

export const siteInspectionSchema = z.object({
  id: z.string().optional(),
  address: z.string().min(1, "Address is required"),
  searchName: z.string().optional(), // Lowercase for autocomplete
  // Scheduling fields (optional - for syncing with availability overrides)
  doctorId: z.string().optional(),
  doctorName: z.string().optional(),
  date: z.string().optional(), // YYYY-MM-DD
  startTime: z.string().optional(), // HH:mm
  endTime: z.string().optional(), // HH:mm
  companyId: z.string().optional(),
  companyName: z.string().optional(),
  phone: z.string().optional(),
  // Link to created availability override
  overrideId: z.string().optional(),
  notes: z.string().optional(),
});

export type SiteInspection = z.infer<typeof siteInspectionSchema>;

// ============================================
// SITE INSPECTION REFERENCE (denormalized in appointments)
// ============================================

export const siteInspectionRefSchema = z.object({
  id: z.string(),
  address: z.string(),
  notes: z.string().optional(),
});

export type SiteInspectionRef = z.infer<typeof siteInspectionRefSchema>;

// ============================================
// CREATE SITE INSPECTION DTO
// ============================================

export const createSiteInspectionSchema = z.object({
  address: z.string().min(1, "Address is required"),
  // Scheduling fields (optional)
  doctorId: z.string().optional(),
  date: z.string().optional(), // YYYY-MM-DD
  startTime: z.string().optional(), // HH:mm
  endTime: z.string().optional(), // HH:mm
  companyId: z.string().optional(),
  phone: z.string().optional(),
  notes: z.string().optional(),
});

export type CreateSiteInspection = z.infer<typeof createSiteInspectionSchema>;

// ============================================
// UPDATE SITE INSPECTION DTO
// ============================================

export const updateSiteInspectionSchema = createSiteInspectionSchema.partial();

export type UpdateSiteInspection = z.infer<typeof updateSiteInspectionSchema>;

// ============================================
// UTILITY FUNCTION
// ============================================

export function createSiteInspectionSearchName(address: string): string {
  return `${address}`.toLowerCase().trim();
}
